import store from 'src/store/index';
import { throttle } from '@lhb/func';
import { retryExecute } from '@/common/utils/ways';
/**
 * 指令-滚动缓存
 * @description 滚动缓存指令，用于在组件激活时恢复滚动位置
  // 注册指令
  import { scrollCacheDirective } from './directives/ScrollCache';
  Vue.directive('scroll-cache', scrollCacheDirective);

 * @return {*}
 * @demo
  <div ref="scrollContainer" v-scroll-cache="Math.random()">
    <!-- 内容 -->
  </div>

  activated() {
    // 组件激活时恢复滚动位置
    this.$nextTick(() => {
      (this.$refs as any).scrollContainer?._scrollCache?.restoreScroll?.();
    });
  }
 */
export var scrollCacheDirective = {
    bind: function (el, binding) {
        var key = binding.value;
        if (!key) {
            return;
        }
        // console.log('(store.state as any).common.scrollStates', (store.state as any).common.scrollStates);
        // 在元素上存储 key
        el.dataset.scrollCacheKey = key;
        /** 保存滚动位置 */
        var saveScroll = throttle(function () {
            // console.log('scrollTop', el.scrollTop);
            store.commit('UPDATE_SCROLL_STATE', {
                key: key,
                scrollTop: el.scrollTop,
                scrollLeft: el.scrollLeft
            });
        }, 200);
        /** 恢复滚动位置 */
        var restoreScroll = function () {
            var state = store.state.common.scrollStates[key];
            if (state) {
                el.scrollTop = state.scrollTop;
                el.scrollLeft = state.scrollLeft;
                return true;
            }
            return false;
        };
        /** 滚动缓存清理 */
        var cleanupScrollCache = function () {
            // 清理滚动缓存
            store.commit('CLEAR_SCROLL_STATE', key);
        };
        // 监听滚动
        el.addEventListener('scroll', saveScroll);
        // 存储相关方法以便清理
        el._scrollCache = {
            key: key,
            saveScroll: saveScroll,
            restoreScroll: function () { return retryExecute(restoreScroll); },
            cleanupScrollCache: cleanupScrollCache,
        };
        // 初始恢复
        setTimeout(restoreScroll, 50);
    },
    updated: function (el) {
        var _a;
        // 更新后恢复滚动位置
        if ((_a = el._scrollCache) === null || _a === void 0 ? void 0 : _a.restoreScroll) {
            setTimeout(el._scrollCache.restoreScroll, 50);
        }
    },
    // actived() {
    //   // 更新后恢复滚动位置
    //   if (el._scrollCache?.restoreScroll) {
    //     setTimeout(el._scrollCache.restoreScroll, 50);
    //   }
    // },
    unbind: function (el) {
        var _a, _b;
        // 清理
        if (el._scrollCache) {
            (_b = (_a = el._scrollCache).cleanupScrollCache) === null || _b === void 0 ? void 0 : _b.call(_a);
            el.removeEventListener('scroll', el._scrollCache.saveScroll);
            delete el._scrollCache;
        }
    }
};
